import ActionDropdown from "../../ActionDropdown";
import TableCheck from "../TableCheck";
import ImageAndName from "../../ImageAndName";
import DateFormatter from "../../DateFormatter";
import { dateFine } from "../../../util/Utilities";
import { safeFormatCLP } from "../../../util/format";

const RequestedProductColumn = [
    {
        Label: TableCheck,
        Component: TableCheck

    },
    {
        Label: () => 'Nro. de pedido',
        Component: ({ value }) => `${value?.orderId}`
    },
    {
        Label: () => 'Código',
        Component: ({ value }) => `${value?.productCode ?? '--'}`
    },
    {
        Label: () => 'Nombre',
        Component: ({ value }) => `${value?.name}`
    },
    {
        Label: () => 'Cantidad',
        Component: ({ value }) => `${value?.quantity}`
    },
    {
        Label: () => 'Precio',
        Component: ({ value }) => safeFormatCLP(value?.price)
    },
    {
        Label: () => 'Total',
        Component: ({ value }) => safeFormatCLP(value?.total)
    },
    {
        Label: () => 'Servicio',
        Component: ({ value }) => `${value?.service?.name}`
    },
    {
        Label: () => 'Categoría',
        Component: ({ value }) => `${value?.category?.name || '--'}`
    },
    {
        Label: () => 'Estado',
        Component: ({ value }) => <div className={`btn btn-xs btn-${value?.status?.variant_color}`} >
            {value?.status?.name}
        </div>
    },
    {
        Label: () => 'Proveedor',
        Component: ({ value }) => value?.providerName
    },
    {
        Label: () => 'Fecha de Creación',
        Component: ({ value }) => value?.createdAt ? <DateFormatter value={dateFine(value?.createdAt)} dateFormat="dd/MM/yyyy hh:mm:ss" /> : null
    }
];

export default RequestedProductColumn;

